
import {defineComponent} from 'vue'
import {UIStateDto} from "@/dtos/UIStateDto";
import {ErrorHandlerQueue} from "@/error/ErrorHandlerQueue";
import {DpExceptionsErrorHandler} from "@/error/handlers/DpExceptionsErrorHandler";
import BaseTitle from "@/components/UI/BaseTitle.vue";
import BaseContainer from "@/components/UI/Bootstrap/BaseContainer.vue";
import {useToast} from "vue-toastification";
import AlertError2 from "@/components/UI/Bootstrap/Alert/AlertError2.vue";
import {AbilityContext} from "@/context/AbilityContext";
import {StatusEnum} from "@/api/enums/status-enum";
import {ValueEnum} from "@/api/enums/value-enum";
import {handleSavedSuccessfully} from "@/helpers/toast-helper";
import {AxiosErrorHandler} from "@/error/handlers/AxiosErrorHandler";
import {DeliveryPickupLocationRestService} from "@/services/rest/settings/DeliveryPickupLocationRestService";
import {DeliveryPickupLocationOverviewRestDto} from "@/api/pharma-order-settings/models";
import {arrayHasContent} from "@/helpers/functions/arrays";

export default defineComponent({
  name: "DeliveryPickupLocationOverview",
  components: {
    BaseContainer,
    BaseTitle,
    AlertError2,
  },
  computed: {
    StatusEnum() {
      return StatusEnum
    },
    AbilityContext() {
      return AbilityContext;
    },
    locations(): DeliveryPickupLocationOverviewRestDto[] {
      return this.deliveryPickupLocations;
    },
    hasLocations(): boolean {
      return arrayHasContent(this.locations);
    },
  },
  data: () => ({
    deliveryPickupLocations: [] as DeliveryPickupLocationOverviewRestDto[],

    toaster: useToast(),
    pageUI: UIStateDto.createWithDefaults(),
  }),
  mounted() {
    this.reloadContent();
  },
  methods: {
    async reloadContent(): Promise<void> {
      this.pageUI
        .setNotReady()
        .clearError();

      try {
        this.deliveryPickupLocations = await DeliveryPickupLocationRestService.getInstance().findDeliveryPickupLocations();
      } catch (exceptions: unknown) {
        this.setExceptions(exceptions);
      } finally {
        this.pageUI.setReady();
      }
    },
    async updateStatus(id: string, status: ValueEnum): Promise<void> {
      this.pageUI
        .setNotReady()
        .clearError();

      try {
        await DeliveryPickupLocationRestService.getInstance().updateDeliveryPickupLocationStatus(status, id);
        await this.afterSave();
      } catch (exceptions: unknown) {
        this.setExceptions(exceptions);
      } finally {
        this.pageUI.setReady();
      }
    },
    async afterSave(message?: string): Promise<void> {
      window.scrollTo(0, 0);
      await handleSavedSuccessfully(message);
      await this.reloadContent();
    },
    setExceptions(exceptions: unknown): void {
      ErrorHandlerQueue
        .create()
        .add(DpExceptionsErrorHandler.createWithDefaultUIStateBehavior(this.pageUI as UIStateDto))
        .add(AxiosErrorHandler.createWithDefaultUIStateBehavior(this.pageUI as UIStateDto))
        .catch(exceptions, true);
    },
    async deleteLocation(id: string): Promise<void> {
      const answer = window.confirm(this.$t('deleteConfirmation'));

      if (answer) {
        this.pageUI
          .setNotReady()
          .clearError();

        try {
          await DeliveryPickupLocationRestService.getInstance().deleteDeliveryPickupLocation(id);

          await this.afterSave(this.$t('deletedSuccessfully'));
        } catch (exceptions: any) {
          this.setExceptions(exceptions);
        } finally {
          this.pageUI.setReady();
        }
      }

    }
  }
})
